import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import TableContainer from "../../../Components/Common/TableContainer";
import {
  useDeleteQuartier,
  useQuartiers,
} from "../../../hooks/useGeography";

const Quarter = (props) => {
  const [selectedQuarter, setSelectedQuarter] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const { data: quarter = [], isLoading, error } = useQuartiers();
  const deleteQuartierMutation = useDeleteQuartier();

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const onClickDelete = (quarterItem) => {
    setSelectedQuarter(quarterItem);
    setDeleteModal(true);
  };

  const handleDeleteQuarter = async () => {
    if (selectedQuarter && selectedQuarter.id) {
      deleteQuartierMutation.mutate(selectedQuarter.id, {
        onSuccess: () => {
          setDeleteModal(false);
        },
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (quarter) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={quarter.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("QUARTIER"),
        accessor: "name",
        Cell: (quarter) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">{quarter.row.original.name}</p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("ARRONDISSEMENT"),
        Cell: (quarter) => {
          return (
            <>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <p className="fs-14 mb-1">
                    {quarter.row.original.arrondissementName || "-"}
                  </p>
                </div>
              </div>
            </>
          );
        },
      },
      {
        Header: "ACTIONS",
        Cell: (quarter) => {
          const quarterData = quarter.row.original;
          return (
            <div>
              <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to={`/geolocalisation-quartier-update/${quarterData.id}/`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-pencil-fill align-bottom" />{" "}
                </Link>
              </li>
              <Link
                to="#"
                className="text-danger d-inline-block"
                onClick={() => onClickDelete(quarterData)}
              >
                <i className="ri-delete-bin-5-line me-2 align-middle text-danger"></i>
              </Link>
            </div>
          );
        },
      },
    ],
    [props]
  );

  document.title = props.t("Quartier - Le Conseiller du BTP");

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteQuarter}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Quartier")}
          pageTitle={props.t("Liste des quartiers")}
        />
        <Row>
          <Col lg={12}>
            <Card id="orderList">
              <CardHeader className="card-header border-0">
                <div className="d-flex.align-items-center">
                  <div></div>
                  <button className="btn btn-info add-btn">
                    <Link
                      to={`/geolocalisation-quartier-add`}
                      className="text-white d-inline-block"
                    >
                      <i className="ri-add-fill me-1 align-bottom" />{" "}
                      {props.t("Ajouter un quartier")}{" "}
                    </Link>
                  </button>
                </div>
              </CardHeader>
            </Card>
            <Card id="orderList">
              <CardBody className="pt-0">
                <div>
                  {isLoading ? (
                    // If loading, show loading indicator
                    <div className="py-4 text-center">
                      <div>
                        <lord-icon
                          src="https://cdn.lordicon.com/xjovhxra.json"
                          trigger="loop"
                          colors="primary:#0960b6,secondary:#02376b"
                          style={{ width: "72px", height: "72px" }}
                        ></lord-icon>
                      </div>
                      <div className="mt-4">
                        <h5>{props.t("Chargement")}...</h5>
                      </div>
                    </div>
                  ) : error ? (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{error.message || props.t("Une erreur est survenue")}</h5>
                      </div>
                    </div>
                  ) : quarter && quarter.length > 0 ? (
                    <TableContainer
                      columns={columns}
                      data={quarter || []}
                      isGlobalFilter={true}
                      isAddUserList={false}
                      customPageSize={8}
                      className="custom-header-css"
                      divClass="table-responsive table-card mb-3"
                      tableClass="align-middle table-nowrap"
                      theadClass="table-light"
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Désolé, pas de resultats trouvés")}</h5>
                      </div>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

Quarter.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Quarter));
